import styled, { keyframes } from "styled-components";

interface PropsMustHave {
  isVisible: boolean;
}

interface PropsRule {
  isCheked: boolean;
}

const fadeIn = keyframes`
  from {
    transform: scale(.25);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    transform: scale(1);
    opacity: 1;
  }

  to {
    transform: scale(.25);
    opacity: 0;
  }
`;

export const Title = styled.h1`
  font-size: 1.25rem;
  color: ${({ theme }) => `${theme.colors.primary}`};
  text-align: center;
  margin-bottom: 3rem;
  margin-top: 1rem;

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const LinkSignIn = styled.div`
  margin: 1rem 0 2rem;

  a {
    display: flex;
    justify-content: center;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.primary};

    &:active {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const ContentStep1 = styled.div`
  button {
    margin: 2rem 0;
  }
`;

export const Form = styled.form`
  width: 100%;

  div {
    & + div {
      margin-top: 0.25rem;
    }
  }

  > a {
    display: flex;
    justify-content: flex-end;
    color: ${({ theme }) => `${theme.colors.primary}`};
    margin: 1rem 0 4rem;
    text-decoration: none;
    font-size: 0.75rem;
  }

  > button {
    margin: 2rem 0;
  }

  @media (min-width: 768px) {
    > a {
      font-size: 0.875rem;
    }
  }
`;

export const Musthave = styled.div<PropsMustHave>`
  display: ${({ isVisible }) => (isVisible ? "flex" : "none")};
  animation: ${({ isVisible }) => (isVisible ? fadeIn : fadeOut)} 0.7s;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
`;

export const Rule = styled.div<PropsRule>`
  color: ${({ theme, isCheked }) =>
    isCheked ? theme.colors.orange : theme.colors.error};
  font-size: 0.75rem;

  & + div {
    margin-top: 0.25rem;
  }

  @media (min-width: 768px) {
    font-size: 0.875rem;
  }
`;
